import { GroupCodeRedeemError } from '../dal/group-code-dal'

export type VoucherRedeemErrorKey =
  | 'invalid_code'
  | 'expired_code'
  | 'already_redeemed'
  | 'network_error'
  | 'unknown_error'

function extractBodyHint(body: unknown): string {
  if (typeof body === 'string') return body
  if (
    body != null &&
    typeof body === 'object' &&
    'message' in body &&
    typeof (body as { message: unknown }).message === 'string'
  ) {
    return (body as { message: string }).message
  }
  return ''
}

function containsAny(haystack: string, needles: string[]): boolean {
  const lower = haystack.toLowerCase()
  return needles.some((n) => lower.includes(n))
}

export function mapRedeemErrorToKey(error: Error): VoucherRedeemErrorKey {
  if (!(error instanceof GroupCodeRedeemError)) {
    return 'unknown_error'
  }

  const { status, body, rawResponseText } = error
  const hint = extractBodyHint(body) || rawResponseText || ''

  if (status == null) {
    return 'network_error'
  }

  if (status === 400 || status === 404 || status === 422) {
    if (containsAny(hint, ['expir'])) return 'expired_code'
    if (containsAny(hint, ['already', 'redeem'])) return 'already_redeemed'
    return 'invalid_code'
  }

  if (status >= 500) {
    return 'unknown_error'
  }

  return 'unknown_error'
}

export function isIgnorableGroupCodeRedeemError(error: unknown): boolean {
  if (!(error instanceof GroupCodeRedeemError)) {
    return false
  }

  const key = mapRedeemErrorToKey(error)

  return (
    key === 'invalid_code' ||
    key === 'expired_code' ||
    key === 'already_redeemed'
  )
}
